/**
 * Cuánto se queda en pantalla un aviso, en UN SOLO SITIO (2026-08-27).
 *
 * La aplicación tiene DOS sistemas de avisos —el de `useToast` y el de
 * sonner— y hasta hoy cada uno llevaba sus números a mano. Estaban en 700 ms
 * en el móvil para todo, errores incluidos: un cliente intentó dar de alta a
 * un trabajador con un espacio en el nombre de usuario y el motivo apareció y
 * desapareció antes de que pudiera leerlo.
 *
 * La distinción que importa no es móvil/escritorio, es ACIERTO contra ERROR:
 *
 *   · Un acierto se lee de refilón, y ni eso hace falta: ya se ve en la
 *     pantalla que la cosa salió. Un segundo, y a otra cosa.
 *   · Un error hay que LEERLO, porque dice qué corregir. Y a veces son dos
 *     líneas, en un móvil, a pleno sol.
 */
export const AVISO_MS = {
  /** Acierto, aviso suelto, información. */
  ok: 1_000,
  /** Error y advertencia: lo que hay que dar tiempo a leer. */
  error: 2_000,
} as const;

/** La forma de `toast.error`, `toast.success`… de sonner. */
type FnAviso = (mensaje: never, opciones?: { duration?: number }) => string | number;

/**
 * Envuelve una función de aviso para que dure `ms` POR DEFECTO.
 *
 * «Por defecto» es la palabra importante: quien llama sigue mandando. Si un
 * sitio concreto pide `{ duration: 8000 }` porque su mensaje es largo, se
 * respeta — por eso las opciones de quien llama van DESPUÉS al fusionar.
 * Al revés, esto pisaría en silencio decisiones tomadas a conciencia.
 */
export const conDuracion = (fn: FnAviso, ms: number): FnAviso =>
  (mensaje, opciones) => fn(mensaje, { duration: ms, ...(opciones ?? {}) });
